import { action } from 'typesafe-actions';

import { MLDataValue } from '../../../datasets/store/mlTypes';
import { PdfSearchResults } from '../../document-viewer/store/types';
import { ChatbotActionTypes } from './types';

export const toggleChatbotModal = (value: boolean) => action(ChatbotActionTypes.TOGGLE_CHATBOT_MODAL, value);
export const resetChatbotModal = () => action(ChatbotActionTypes.RESET_CHATBOT_MODAL);
export const askChatbotStarted = (question: string) => action(ChatbotActionTypes.ASK_CHATBOT_STARTED, question);
export const askChatbotSuccessful = (value: MLDataValue, page: number | undefined, snippet: string | undefined, highlightIndexes: number[], isFuzzyMatchHighlight = false) => action(ChatbotActionTypes.ASK_CHATBOT_SUCCESSFUL, { value, page, snippet, highlightIndexes, isFuzzyMatchHighlight });
export const askChatbotFailed = (error: string) => action(ChatbotActionTypes.ASK_CHATBOT_FAILED, error);
export const resetChatbotResults = () => action(ChatbotActionTypes.RESET_CHATBOT_RESULTS);

export const setAISortedResults = (results: PdfSearchResults) => action(ChatbotActionTypes.SET_AI_SORTED_RESULTS, results);
